<!-- <img src="../ui/assets/img/headline.svg" alt="Bosch-headline" /> -->
<div id="HTMLContent" class="div-MainScene">
  <header id="HTML-Row1" class="w-full flex justify-center items-center py-4">
    <img src="../ui/assets/img/UrlS.svg" alt="bos.ch/dev" class="h-40 w-auto mx-auto" />
  </header>

</div> 
